module.exports = __webpack_public_path__ + "57980878dac89956c714a7e861c2273f.jpg";